














import { defineComponent, onMounted, onUnmounted, ref } from "@vue/composition-api";
import CategoriesBlock from "./components/CategoriesBlock";
import FaqBlock from "./components/FaqBlock";
import FeaturesBlock from "./components/FeaturesBlock";
import FooterBlock from "./components/FooterBlock";
import HeaderBlock from "./components/HeaderBlock";
import HeroBlock from "./components/HeroBlock";
import JoinWideBlock from "./components/JoinWideBlock";

export default defineComponent({
  name: "PageLanding",
  components: {
    FooterBlock,
    JoinWideBlock,
    FaqBlock,
    FeaturesBlock,
    CategoriesBlock,
    HeroBlock,
    HeaderBlock,
  },
  setup() {
    const target = ref();
    const scrolled = ref(false);

    const observer = new IntersectionObserver(
      ([entry]) => {
        scrolled.value = !entry.isIntersecting;
      },
      { threshold: 0 }
    );
    onMounted(() => {
      observer.observe(target.value);
    });

    onUnmounted(() => {
      observer.disconnect();
    });

    return {
      target,
      scrolled,
    };
  },
});
